import React, { useState, useEffect, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { InputText,Checkbox,Button,Toast,Dialog,Dropdown} from "primereact";
import { Formik } from 'formik';
import axios from "axios";
import Costanti from '../../constantiX';
import {FormattedMessage, useIntl} from 'react-intl';


class Login extends React.Component {
    constructor() {
        super();
        this.state = { email:'', password:'',xcarica:'sezione', tipoVisual:0 , width: 0, height: 0,  dati:[] };
        this.onInputchange = this.onInputchange.bind(this);
        this.onSubmitForm = this.onSubmitForm.bind(this);
        this.token="";
        this.aziendaid=0;
         this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      }
      
      updateWindowDimensions() {

        var tipow=3;
        if(window.innerWidth>=0 && window.innerWidth<727)tipow=1;
        if(window.innerWidth>=728 && window.innerWidth<1024)tipow=2;
        
        this.setState({ tipoVisual : tipow, width: window.innerWidth, height: window.innerHeight });
      }
      componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
      }
      
      componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        sessionStorage.setItem("isAutenticate",false);
      
        sessionStorage.removeItem("ruoloid");
        sessionStorage.removeItem("isAutenticate");
        sessionStorage.removeItem("utente");
        sessionStorage.removeItem("ICEtoken");

        var quer='page=1&num=1000';
        axios.get(Costanti.UrlCallApi+"azienda/all?"+quer)
        .then(res => {
            this.setState({listaazienda:res.data.lista1,totalRecords:res.data.conta1,loading:false})
           }).catch(error=> {
            // alert(error)
        });
    
          
      }

      

      redirect(val) {
        let config = {
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }

        
        sessionStorage.setItem("DecoLotto1","	Data Lotto");
        sessionStorage.setItem("DecoLotto2","Data Scadenza");
        sessionStorage.setItem("DecoStabilimento","Stabilimento");
        sessionStorage.setItem("LottoCliente","");
        sessionStorage.setItem("Allegerni","");

        axios.get(Costanti.UrlCallApi+"decodifica/all?aziendaid="+this.utente.aziendaid+"&tipo=1",config)
        .then(res => {


           res.data.lista1.forEach(element => {
            if(element.nome=='stabilimento')  
              sessionStorage.setItem("DecoStabilimento",element.valore1);
             if(element.nome=='DecoLotto1')  
               sessionStorage.setItem("DecoLotto1",element.valore1);
             if(element.nome=='DecoLotto2')  
               sessionStorage.setItem("DecoLotto2",element.valore1);
             if(element.nome=='LottoCliente')  
                sessionStorage.setItem("LottoCliente",element.valore1);
             if(element.nome=='Allergeni')  
                sessionStorage.setItem("Allergeni",element.valore1);
             if(element.nome=='Annate')  
                sessionStorage.setItem("Annate",element.valore1);
    
          
            });
            
        }).catch(error=> {
            //alert(JSON.stringify(error))
             this.showMessage('error','Errore carico decodiche','');
        });
       

        this.setState({scegli:false});
        if(val==2) {
         this.props.history.push('/dashboard')
        }   
        if(val>=3) {
          this.props.history.push('/azienda')
        } 
        if(val==1) {
          this.setState({scegli:true});
        } 
      } 

      showMessage(tipo,messageError,dettaglio) {
        var icona='';
        if(tipo=='error'){
          icona='pi pi-times-circle';
        }
        if(tipo=='info'){
          icona='pipi-info-circle';
        }
        if(tipo=='success'){
          icona='pi pi-check-circle';
        }
        if(tipo=='warning'){
          icona='pi pi-exclamation-triangle';
        }
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                 <h4>{messageError}</h4>
                 <h5>{dettaglio}</h5>
                </div>
            </div>
        ) });
      }
      onSubmitForm() {
        this.setState({loading:true});
      
       var din={
          'email':this.state.dati.email,
          'password':this.state.dati.password,
          'apiKey':''
        }
      
    /*
    var din2={
          'email':'ut1@example.com',
          'password':'angelo',
          'apiKey':''
        }
        */
        sessionStorage.clear();
        axios.post(Costanti.UrlCallApi+"auth/login",din)
        .then(res => {
     
            this.showMessage('success','Autenticazione avvenuta','');
            sessionStorage.setItem("ruoloid",res.data.ruoloid);
            sessionStorage.setItem("isAutenticate",true);
             sessionStorage.setItem("utente",JSON.stringify(res.data));
            this.utente=res.data;
            sessionStorage.setItem("ICEtoken",res.data.token);
            this.token=res.data.token;
            this.setState({loading:false});
         
            if(res.data.status=='P'){
              this.setState({preset2:true});
            }else{
               setTimeout(()=>this.redirect(res.data.ruoloid),1000);
            }
            
        }).catch(error=> {
            //alert(JSON.stringify(error))
             this.showMessage('error','Errore nell\'autenticazione',error.message);
             this.setState({loading:false});
        });
       
      }
    

      onInputchange(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.id
        let x = this.state.dati;
        x[name] = value;
        this.setState({ dati: x });
       
      }

      invia() {
        this.setState({loading:true});
        var din={
          'email':this.state.dati.email2,
          'password':'',
          'apiKey':''
        }
      
        axios.post(Costanti.UrlCallApi+"auth/resetpass",din)
        .then(res => {
            this.showMessage('success','Mail inviata','');
            this.setState({loading:false});
        }).catch(error=> {
            //alert(JSON.stringify(error))
             this.showMessage('error','Errore nel reset password',error.message);
             this.setState({loading:false});
   
        });
       
      }
      aggiungi() {
        if(this.nuovaazienda){
        
        let config = {
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }
        this.setState({isSubmitting:true});
      var dati={
        ragionesociale:this.nuovaazienda,
        sigla:this.sigla,
        status:' '
      } 
      axios.post(Costanti.UrlCallApi+"azienda/aggiungi",dati,config)
      .then(res => {
          this.showMessage('success','Dati salvati correttamente','');
          this.setState({isSubmitting:false});
     }).catch(error=> {
        this.showMessage('error','Errore nel salvataggio',error.message);
        this.setState({isSubmitting:false});
      });
        }
      }
     

      invia2() {
        this.setState({loading:true});
        var din={
          'email':this.state.dati.email,
          'password':this.state.dati.password,
          'apiKey':this.state.dati.password2
        }
         if(this.state.dati.password2!=this.state.dati.password3){
            this.showMessage('error','Errore nel reset password','Le password non coincidono');
            this.setState({loading: false});
          }
          else if(this.state.dati.password2.length<8){
            this.showMessage('error','Errore nel reset password','La password deve avere almeno 8 caratteri');
            this.setState({loading: false});
          }else{
         
        axios.post(Costanti.UrlCallApi+"auth/changepassw",din)
        .then(res => {
          
            this.showMessage('success','Password Modificata','');
            this.setState({loading:false});
        }).catch(error=> {
            //alert(JSON.stringify(error))
             this.showMessage('error','Errore nel reset password',error.message);
             this.setState({loading:false});
   
        });
      }
      }


    render() {
      return( 
      <div>
      <Dialog header="Scegli Azienda" 
       closable={false} visible={this.state.scegli} 
       modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} 
       draggable={false} resizable={false}>
      <div className="grid formgrid p-fluid">
             
       <div className="field mb-1 col-12 md:col-6">
            <Dropdown optionLabel="ragionesociale" options={this.state.listaazienda}
                    optionValue="id"
                    value={this.state.aziendaid}
                    onChange={(e)=>{this.utente.aziendaid=e.target.value;
                      this.setState({aziendaid:this.utente.aziendaid});
                      sessionStorage.setItem("utente",JSON.stringify(this.utente));
                    }}
                    placeholder="Seleziona..."/>
        

        </div>
      
       <div className="field mb-1 col-12 md:col-6">
                    <label htmlFor="ragionesociale2" className="font-medium text-600">Nuova Azienda-Ragione Sociale</label>
                    <InputText name="ragionesociale2" value={this.nuovaazienda}   onChange={(e)=>{this.nuovaazienda=e.target.value}} type="text" />
                    <label htmlFor="sigla" className="font-medium text-600">Nuova Azienda-Sigla</label>
                    <InputText name="sigla" value={this.sigla}   onChange={(e)=>{this.sigla=e.target.value}} type="text" />
                    <Button type="button" icon="pi pi-check" onClick={() => this.aggiungi()} label="Aggiungi Nuova Azienda" />
       </div>
       </div>
      
      
        
        <footer>
        <div className="border-top-1 surface-border pt-3">
                <Button type="button" icon="pi pi-check" onClick={() => this.redirect(3)} label="Chiudi" />
             
        </div>
        </footer>
       </Dialog>

      
       <Dialog header="Password Dimenticata" 
       closable={false} visible={this.state.preset} 
       modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} 
       draggable={false} resizable={false}>
             <label htmlFor="email2" className="block text-900 font-medium mb-2">Inserisci Email</label>
             <InputText id="email2" type="text" required onChange={this.onInputchange} className="w-full mb-3" />
      
        <footer>
        <div className="flex justify-content-between text-1000">
                <Button type="button" icon="pi pi-check" onClick={() => this.setState({preset:false,loading:false})} label="Chiudi" />
                <Button type="button button-warning" icon="pi pi-check" loading={this.state.loading}  disabled={this.state.loading}  onClick={() => this.invia()} label="Invia" />
        </div>
            </footer>
       </Dialog>

       <Dialog header="Reset Password" 
       closable={false} visible={this.state.preset2} 
       modal breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} 
       draggable={false} resizable={false}>
             <label htmlFor="password2" className="block text-900 font-medium mb-2">Inserisci la nuova password</label>
             <InputText name="password2" id="password2" type="password" required minLength={5} onChange={this.onInputchange} className="w-full mb-3" />
             <label htmlFor="password3" className="block text-900 font-medium mb-2">Reinserisci la nuova password</label>
              <InputText  name="password3" id="password3" type="password" required minLength={5} onChange={this.onInputchange} className="w-full mb-3" />
      
        <footer>
        <div className="flex justify-content-between text-1000">
                <Button type="button" icon="pi pi-check" onClick={() => this.setState({preset2:false,loading:false})} label="Chiudi" />
                <Button type="button button-warning" icon="pi pi-check" loading={this.state.loading}  disabled={this.state.loading}  onClick={() => this.invia2()} label="Invia" />
        </div>
            </footer>
       </Dialog>

      
      
           <Toast ref={(el) => this.toastBC = el} position="bottom-center" />
           
           {this.state.tipoVisual==3?
             <div className="flex">
                 <div className="surface-section w-2 md:w-6 p-6 md:p-8">
              <div className="mb-5">
                  <img src="assets/images/hyper.svg" alt="hyper" height={50} className="mb-3" />
                  <div className="text-900 text-2xl font-medium mb-3">Benvenuto</div>
                  {/*<span className="text-600 font-medium mr-2">Non hai un accesso?</span>
                  <a className="font-medium no-underline text-blue-500 cursor-pointer">Crealo!</a>*/}
              </div>
              <div>
                  <label htmlFor="email" className="block text-900 font-medium mb-2">Email</label>
                  <InputText id="email" name="email" type="text" required onChange={this.onInputchange} className="w-full mb-3" />
                  <label htmlFor="password" className="block text-900 font-medium mb-2">Password</label>
                  <InputText id="password" name="password" type="password"  onChange={this.onInputchange} className="w-full mb-3" />
                  <div className="flex align-items-center justify-content-between mb-6">

                      <a className="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer" onClick={()=>this.setState({preset:true})} >Password dimenticata?</a>
                  </div>
                  <Button label="Accedi"   loading={this.state.loading}  disabled={this.state.loading}  icon="pi pi-user" className="w-full" onClick={this.onSubmitForm}/>
              </div>
          </div>
          <div className="hidden block w-10 bg-no-repeat bg-cover">
              <img src='assets/images/TrackIT.jpg' width={'100%'}/>
             </div>
             </div>:""
            }
             {this.state.tipoVisual<=2?
             <div className="block">
             
             <div className="surface-section w-12 md:w-12 p-12 md:p-12">
              <div className="flex align-items-center justify-content-between">
              <div className="text-900 text-2xl font-medium mb-3">Benvenuto</div>  <img src='assets/images/TrackIT.jpg' width={'50%'}/>
                  {/*<span className="text-600 font-medium mr-2">Non hai un accesso?</span>
                  <a className="font-medium no-underline text-blue-500 cursor-pointer">Crealo!</a>*/}
              </div>
              <div>
                  <label htmlFor="email" className="block text-900 font-medium mb-2">Email</label>
                  <InputText id="email" name="email" type="text" value={this.state.dati.email} required onChange={this.onInputchange} className="w-full mb-3" />
                  <label htmlFor="password" className="block text-900 font-medium mb-2">Password</label>
                  <InputText id="password" name="password"  type="password" value={this.state.dati.password} onChange={this.onInputchange} className="w-full mb-3" />
                  <div className="flex align-items-center justify-content-between mb-6">

                      <a className="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer" onClick={()=>this.setState({preset:true})} >Password dimenticata?</a>
                  </div>
                  <Button label="Accedi" icon="pi pi-user" className="w-full" onClick={this.onSubmitForm}/>
              </div>   
              
           
          </div>
      
             </div>:""
            }
       
      </div>
      )  
    }

}
export default Login;
